import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useController } from '../hooks/useController'
import { useDeleteDepots } from '../hooks/useDeleteDepots'
import { useTexts } from '../hooks/useTexts'

export function Footer() {
  const texts = useTexts()
  const { status, close } = useController()
  const [submitting, deleteRegion] = useDeleteDepots()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          loading={submitting}
          onClick={deleteRegion}
          variant="contained"
          testid="modal-primary-button"
          color="error"
        >
          {texts.confirmButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
